import { useQuery } from "react-query";
import axios from "axios";
import {
  IContactForm,
  IContactFormConfig,
  IPublicContact,
} from "../dto/IContactForm";

const queryKeys = {
  getForm: "settingsService.getForm",
  getLogo: "settingsService.getLogo",
  getContacts: "settingsService.getContacts",
  getConfig: "settingsService.getConfig",
};

const getContacts = (
  searchString?: string
): Promise<{ data: IPublicContact[] }> => {
  return axios.get(
    import.meta.env.VITE_APP_API_URL +
      `/contactform/addressBook?searchString=${searchString}`
  );
};

const useGetContacts = (searchString?: string, enabled: boolean = true) => {
  return useQuery(queryKeys.getContacts, () => getContacts(searchString), {
    enabled: enabled,
  });
};

const getForm = (key?: string): Promise<{ data: IContactForm }> => {
  return axios.get(
    import.meta.env.VITE_APP_API_URL + `/contactform/hosted?id=${key}`
  );
};

const useGetForm = (key?: string, enabled: boolean = true) => {
  return useQuery(queryKeys.getForm, () => getForm(key), { enabled: enabled });
};

const getLogo = (key: string) => {
  return axios.get(
    import.meta.env.VITE_APP_API_URL + `/contactForm/logo?id=${key}`,
    {
      responseType: "blob",
    }
  );
};

const useGetLogo = (key: string, enabled: boolean = true) => {
  return useQuery(queryKeys.getLogo, () => getLogo(key), {
    enabled: enabled,
    retry: false,
  });
};

const getConfig = (): Promise<{ data: IContactFormConfig }> => {
  return axios.get(import.meta.env.VITE_APP_API_URL + `/contactform/config`);
};

const useGetConfig = () => {
  return useQuery(queryKeys.getConfig, () => getConfig(), {
    staleTime: Infinity,
    retry: false,
  });
};

export default {
  useGetForm,
  useGetLogo,
  useGetContacts,
  useGetConfig,
};
